import { gql } from '@apollo/client';
export const LOCALE_FIELDS = gql `
  fragment LocaleFields on LocaleInfo {
    identifier
    displayName
    englishName
    currencies {
      code
      symbol
      name
    }
  }
`;
export const ALL_TIMEZONES = gql `
  query ALL_TIMEZONES {
    allTimezones
  }
`;
